/* ==========================================================================
   PanelVehicle > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { initCheckboxToggle } = require('./checkboxToggle');
const { initInput } = require('./input');
const { initSelect } = require('./select');
const config = require('./config');
const { updateUi } = require('./ui');

/**
 * PanelVehicle component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function PanelVehicle(selector = '[data-component="PanelVehicle"]', configuration = {}) {
    if (elementExist(selector)) {
        /* Instance reference */
        const instance = {};

        /* Element reference */
        instance.element = document.querySelector(selector);

        /* Config */
        instance.config = { ...config(), ...configuration };

        /* Init vehicle */
        instance.vehicle = {
            product: initSelect(
                `${selector} [data-component="Select"][data-type="${config().type.product}"]`,
                {
                    ...configuration.select,
                    onChangeSelect: instance.config.onChangeSelect
                },
                instance
            ),
            length: initInput(
                `${selector} [data-component="Input"][data-type="${config().type.length}"]`,
                {
                    ...configuration.input,
                    onChangeInput: instance.config.onChangeInput
                },
                instance
            ),
            height: initInput(
                `${selector} [data-component="Input"][data-type="${config().type.height}"]`,
                {
                    ...configuration.input,
                    onChangeInput: instance.config.onChangeInput
                },
                instance
            )
        };

        /* Init extra */
        instance.extra = {
            length: initInput(
                `${selector} [data-component="Input"][data-type="${config().type.extra.length}"]`,
                {
                    ...configuration.input,
                    onChangeInput: instance.config.onChangeInput
                },
                instance
            ),
            height: initInput(
                `${selector} [data-component="Input"][data-type="${config().type.extra.height}"]`,
                {
                    ...configuration.input,
                    onChangeInput: instance.config.onChangeInput
                },
                instance
            ),
            toggle: initCheckboxToggle(
                `${selector} [data-component="CheckboxToggle"][data-type="${config().type.extra.toggle}"]`,
                {
                    ...configuration.toggle,
                    onChangeToggle: instance.config.onChangeToggle
                },
                instance
            )
        };

        /* Init visibility  */
        updateUi(instance);

        return instance;
    }
};
